import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import IconRestriction from '../Icons/IconRestriction';
import IconException from '../Icons/IconException';
import IconNotes from '../Icons/IconNotes';
import { TextMedium } from '../../common/text';
import { ChartRow, RowItem } from '../_charts/ChartRowAndHeader.styles';
import { TIME_FORMAT, DURATION_FORMAT } from '../../common/constants';

export const TurbineStatusChartRow = ({ data }) => {
    if (data.key === 'TURBINE_STATUS_HEADER') {
        return (
            <ChartRow>
                <RowItem width="150">
                    <TextMedium bold>Turbine Status</TextMedium>
                </RowItem>
                <RowItem width="100">
                    <TextMedium bold>Start Time</TextMedium>
                </RowItem>
                <RowItem width="100">
                    <TextMedium bold>End Time</TextMedium>
                </RowItem>
                <RowItem width="100">
                    <TextMedium bold>Duration</TextMedium>
                </RowItem>
            </ChartRow>
        );
    }

    if (['RESTRICTIONS_HEADER', 'NOTES_HEADER', 'EXCEPTIONS_HEADER'].includes(data.key)) {
        return (
            <ChartRow>
                <RowItem>
                    <TextMedium bold>{`${data.type} (${data.count})`}</TextMedium>
                </RowItem>
            </ChartRow>
        );
    }

    const isTurbineStatus = data.key === 'TURBINE STATUS';
    return (
        <ChartRow>
            {isTurbineStatus ? (
                <RowItem width="150">
                    <TextMedium>{data.description}</TextMedium>
                </RowItem>
            ) : (
                <RowItem flex="auto">
                    <TextMedium>{data.description}</TextMedium>
                </RowItem>
            )}
            {isTurbineStatus && (
                <RowItem width="100">
                    <TextMedium bold>{moment(data.beginDate).format(TIME_FORMAT)}</TextMedium>
                </RowItem>
            )}
            {isTurbineStatus && (
                <RowItem width="100">
                    <TextMedium bold>{moment(data.endDate).format(TIME_FORMAT)}</TextMedium>
                </RowItem>
            )}
            {isTurbineStatus && (
                <RowItem width="100">
                    <TextMedium bold>
                        {moment.duration(moment(data.endDate).diff(moment(data.beginDate))).format(...DURATION_FORMAT)}
                    </TextMedium>
                </RowItem>
            )}
            <RowItem flex="initial">
                {data.key === 'NOTES' && <IconNotes size={13} />}
                {data.key === 'RESTRICTIONS' && <IconRestriction size={13} />}
                {data.key === 'EXCEPTIONS' && <IconException size={13} />}
            </RowItem>
        </ChartRow>
    );
};

TurbineStatusChartRow.displayName = 'TurbineStatusChartRow';

TurbineStatusChartRow.propTypes = {
    data: PropTypes.object,
};

TurbineStatusChartRow.defaultProps = {};
